<!-- Coupon -->
<div *ngIf="data['source']=='Active Coupon'">
    <h1 mat-dialog-title style="font-weight: 500;">Alert</h1>
    <div style="width: 25em;font-size: medium;" mat-dialog-content>Are you sure you want to
        {{!data['coupon']['isActive']?'active': 'inactive'}} this coupon?</div>
    <div mat-dialog-actions>
        <button class="no-btn" mat-button mat-dialog-close (click)="close()">No</button>
/    </div>
</div>